export default function AboutSection() {
  return (
    <section id="about" className="py-16 md:py-20 bg-background-50">
      <div className="max-w-4xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <span className="inline-flex items-center gap-1.5 bg-secondary-100 text-secondary-700 text-xs font-semibold px-3 py-1 rounded-full mb-4">
            <i className="ri-information-line text-sm"></i>
            了解我们
          </span>
          <h2 className="text-3xl md:text-4xl font-bold text-foreground-950 font-heading mb-3">
            关于我们
          </h2>
          <p className="text-foreground-600 text-sm md:text-base max-w-lg mx-auto">
            国内领先的吃瓜社区平台，致力于为吃瓜群众提供最优质的爆料内容
          </p>
        </div>

        <div className="bg-background-100 rounded-3xl border border-background-200 p-8 md:p-10">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            <div className="text-center md:text-left">
              <div className="w-12 h-12 flex items-center justify-center rounded-xl bg-primary-100 text-primary-600 mx-auto md:mx-0 mb-4">
                <i className="ri-eye-line text-2xl"></i>
              </div>
              <h3 className="text-foreground-950 text-base font-bold mb-2">我们的使命</h3>
              <p className="text-foreground-600 text-sm leading-relaxed">
                91黑料吃瓜致力于打造国内最大最活跃的吃瓜社区，为吃瓜群众提供真实、及时、全面的娱乐圈爆料内容。我们相信每个人都有权利了解真相，我们的使命是让信息更透明、让八卦更有料。
              </p>
            </div>
            <div className="text-center md:text-left">
              <div className="w-12 h-12 flex items-center justify-center rounded-xl bg-accent-100 text-accent-600 mx-auto md:mx-0 mb-4">
                <i className="ri-shield-check-line text-2xl"></i>
              </div>
              <h3 className="text-foreground-950 text-base font-bold mb-2">我们的原则</h3>
              <p className="text-foreground-600 text-sm leading-relaxed">
                我们坚持"真实为本、保护优先"的原则——严格审核每一条爆料内容的真实性，同时采用多层加密技术保护爆料人身份信息。所有标注"待核实"的内容都会在获得更多证据后更新状态。
              </p>
            </div>
            <div className="text-center md:text-left">
              <div className="w-12 h-12 flex items-center justify-center rounded-xl bg-secondary-100 text-secondary-600 mx-auto md:mx-0 mb-4">
                <i className="ri-group-line text-2xl"></i>
              </div>
              <h3 className="text-foreground-950 text-base font-bold mb-2">我们的社区</h3>
              <p className="text-foreground-600 text-sm leading-relaxed">
                目前已有368万注册瓜友活跃在平台上，日均产生2.6万条讨论帖。我们欢迎每一位热爱吃瓜的朋友加入，分享你的独家线索，和全国瓜友一起见证娱乐圈的每一个精彩瞬间。
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}